<template>
  <bvue-ui-view class="" :scroll="true">
    <div class="w-full">
      <button @click="$router.go(-1)" class="btn-back">&#8826; Volver</button>
    </div>
    <!-- {{trees ? trees.length : 0 + ' árboles en total'}} -->
    <div v-if="item.active" class="flex items-center">
      <div class="bg-green rounded-full mr-4" style="width: 10px; height: 10px;" />
      <label class="font-bold">Reserva activa</label>
    </div>
    <div v-else class="flex">
      <button :class="['btn', 'btn-primary', loadingActivate]" @click="activate">Activar la reserva</button>
      <label class="ml-2">Reserva no publicada. La reserva no estará visible hasta que no esté activa. Pero una vez activa no podrás editar los árboles</label>
    </div>
    <div class="flex my-4">
      <div class="flex-1"> 
        <h3 class="">{{item.name}}</h3>
        <div class="chip w-fit cursor-pointer">
          {{ecosystemName}}
          <!-- <img class="ml-4" :src="require('@/assets/images/menu.svg')"/> -->
        </div>
      </div>
      <button class="btn btn-primary" @click="edit">Editar información</button>
    </div>
    <div>
      <label class="price"> {{item.price}} $</label>
      <p class="desc mt-2">{{item.description}}</p>
    </div>
    <div class="flex my-4">
      <h3 class="flex-1">Region</h3>
      <button class="btn btn-primary" @click="editRegion">Editar region</button>
    </div>
    <div class="flex items-center">
      <h3 class="mt-4">Árboles</h3>
      <div class="flex-1 flex justify-end">
        <label :class="['btn', 'btn-primary', 'mr-4', loadingImport]" :disabled="item.active">Importar csv<input type="file" ref="csv" style="display:none;" @change="importCsv"/></label>
        <button @click="add" :class="['btn', 'btn-primary']" :disabled="item.active">Añadir</button>
      </div>
    </div>
    <sortable-table :items="trees" :columns="columns" startSort="date" @rowSelected="rowSelected"/>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
import { mapGetters } from 'vuex';
import SortableTable from '@/components/SortableTable'
import NewReserve from '@/pages/admin/NewReserve'
import PathEditor from '@/pages/admin/PathEditor'
import TreeDetails from '@/pages/admin/TreeDetails'
import { importCsv } from '@/utils/csvImporter'

export default {
  name: 'ReserveAdminDetails',
  components: { SortableTable, PathEditor },
  props: {
    modalData: Object
  },
  data() {
    return {
      reserveId: null,
      docRef: null,
      loadingImport: [],
      loadingActivate: [],
      columns: [
        {
          key: 'date',
          name: 'fecha',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'lat',
          name: 'latitud',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'lng',
          name: 'longitud',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'specie',
          name: 'Especie',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'altura',
          name: 'Altura',
          key: 'dmtr',
          name: 'diametro',

          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'altura',
          name: 'altura',
          align: 'left',
          sortable: true,
          type: 'text'
        }
      ]
    }
  },
  methods: {
    edit() {
      this.$bvueUi.modal.show({
        component: NewReserve,
        width: 600,
        height: 500,
        data: this.item
      })
    },
    editRegion() {
      console.log('Edit region')
      this.$bvueUi.modal.show({
        component: PathEditor,
        width: 800,
        height: 800,
        data: this.item
      })
    },
    async importCsv(ev) {
      console.log('import CSV')
      this.loadingImport = ['loading', 'disabled']
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = async e => {
        await importCsv(e.target.result, this.reserveId, this.speciesSlugs, this.item.trees)
        this.loadingImport = []
        const input = this.$refs.csv;
        input.type = 'text';
        input.type = 'file';
      }
      reader.readAsText(file)
    },
    add() {
      console.log('Edit region')
      this.$bvueUi.modal.show({
        component: TreeDetails,
        width: 800,
        height: 800,
        data: {
          colRef: this.docRef.collection('trees'),
          item: {},
          editable: !this.item.active
        }
      })
    },
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        console.log('row selected: ', item)
        this.$bvueUi.modal.show({
          component: TreeDetails,
          width: 800,
          height: 800,
          data: {
            colRef: this.docRef.collection('trees'),
            item: item.tree,
            editable: !this.item.active
          }
        })
      }
    },
    isTouchable() {
      return ("ontouchstart" in document.documentElement)
    },
    async activate() {
      const response = await this.$dialogs.alert('Esta acción no es reversible. Una vez activada una reserva no podrás modificar la información de los árboles. ¿Estás completamente seguro de querer activar la resrva?', {title: 'Estás seguro', okLabel: 'Activar'} )
      if (response.ok) {
        // Generar las semillas
        this.loadingActivate = ['loading', 'disabled']
        const seeds = this.docRef.collection('seeds')
        var promises = []
        for (const key in this.item.trees) {
          promises.push(seeds.add({
            ownerId: null,
            planted: null
          }))
        };
        const response = await Promise.all(promises)
        this.docRef.update({active: true})
        this.loadingImport = []
      }
      console.log('activate: ', response)
    }
  },
  computed: {
    item() {
      var response = this.$store.state.reserves.items[this.reserveId]
      if (!response) {
        response = {}
      }
      return response
    },
    ecosystemName() {
      var response = ''
      if (this.item) {
        const ecosystem = this.$store.state.ecosystems.items[this.item.ecosystem]
        if (ecosystem) {
          response = ecosystem.name
        }
      }
      return response
    },
    speciesSlugs() {
      const species = this.$store.state.species.items
      var response = {}
      for (const key in species) {
        const specie = species[key];
        response[specie.slug] = specie.id
      };
      return response
    },
    trees() {
      var response = []
      if (this.item.trees) {
        for (const key in this.item.trees) {
          const tree = this.item.trees[key];
          response.push({
            date: new Date(tree.date),
            lat: tree.position.lat,
            lng: tree.position.lng,
            altura: tree.position.altura,
            dmtr: tree.position.dmtr,
            specie: this.$store.state.species.items[tree.specie].name,
            tree: tree
          })
        }
      }
      return response
    }
  },
  created() {
    this.reserveId = this.$route.params.id
    if (!this.reserveId) {
      this.$router.go(-1)
      return
    }
    this.docRef = firebase.firestore.collection('reserves').doc(this.reserveId)
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';

.desc {
  max-height: 50px;
  overflow-y: scroll; 
}
.price {
  color: $primary-color;
  font-weight: 700;
  font-size: 1.5em;
}
</style>




// WEBPACK FOOTER //
// src/pages/admin/ReserveDetails.vue